import React from 'react'
import { Typography } from '@mui/material'
import { Container } from './styles'
import type { ShiftCardInfoTextProps } from './types'

const ShiftCardInfoText: React.FC<ShiftCardInfoTextProps> = ({ title, subtitle }) => (
  <Container>
    <Typography data-testid="shift-card__unacknowledged-title" variant="body1">
      {title}
    </Typography>
    <Typography data-testid="shift-card__unacknowledged-body" variant="body2">
      {subtitle}
    </Typography>
  </Container>
)

export default ShiftCardInfoText
